import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';

import { IUserManagerConfig } from '../Models/IUserManagerConfig';

export const GetUserManagerSettings = (props: IUserManagerConfig) => {
  const ssoURL = props.ssoURL ?? '';
  const ssoAuthorizationEndpoint = props.ssoAuthorizationEndpoint;
  const ssoTokenEndpoint = props.ssoTokenEndpoint;
  const ssoUserInfoEndpoint = props.ssoUserInfoEndpoint;
  const ssoSignOutEndpoint = props.ssoSignOutEndpoint;
  const ssoClinetId = props.ssoClinetId ?? '';
  const ssoScopes = props.ssoScopes ?? '';
  const ssoSecret = props.ssoSecret ?? '';
  const disablePKCE = props.disablePKCE ?? undefined;

  return {
    client_id: ssoClinetId,
    client_secret: ssoSecret,
    scope: ssoScopes,
    authority: ssoURL,
    redirect_uri: window.location.origin + props.signInCallback,
    silent_redirect_uri: window.location.origin + props.silentCallback,
    response_type: 'code',
    post_logout_redirect_uri: window.location.origin + props.signOutCallBack,
    filterProtocolClaims: true,
    loadUserInfo: true,
    monitorSession: false,
    disablePKCE: disablePKCE ? Boolean(disablePKCE) : undefined,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    metadata:
      ssoAuthorizationEndpoint !== undefined && ssoTokenEndpoint !== undefined && ssoUserInfoEndpoint !== undefined
        ? {
            authorization_endpoint: ssoURL + ssoAuthorizationEndpoint ? ssoURL + ssoAuthorizationEndpoint : undefined,
            token_endpoint: ssoURL + ssoTokenEndpoint ? ssoURL + ssoTokenEndpoint : undefined,
            userinfo_endpoint: ssoURL + ssoUserInfoEndpoint ? ssoURL + ssoUserInfoEndpoint : undefined,
            end_session_endpoint: ssoURL + ssoSignOutEndpoint ? ssoURL + ssoSignOutEndpoint : undefined,
          }
        : undefined,

    automaticSilentRenew: false,
    accessTokenExpiringNotificationTimeInSeconds: 60,
  } as UserManagerSettings;
};
